export const home = {
    en: {
        metaTitle: 'Travel Guide',
        metaDescription:
            'TripLinkHub helps you travel smarter: compare tours, stays, transport, eSIM and VPN for popular destinations. Real reviews, smart filters, best prices.',
        heroTitle: 'Your best journey',
        heroTitleAccent: 'starts here',
        heroSubtitle:
            'Routes, guides, and trusted services for independent travel – all in one place',
        ctaDestination: 'Choose destination',
        sectionDestinations: 'Destinations',
        sectionDestinationsTitle: 'Choose a country',
        sectionDestinationsDesc:
            'Complete travel guides with routes, tips, and curated services',
        sectionBenefits: 'Benefits',
        sectionBenefitsTitle: 'Why TripLinkHub?',
        sectionJournal: 'Journal',
        sectionJournalTitle: 'Articles & Guides',
        sectionCta: 'Time to see more',
        sectionCtaTitle: 'Ready to explore?',
        sectionCtaDesc:
            'Choose your destination and start planning your perfect trip today',
        features: [
            {
                title: 'Curated picks',
                desc: 'Hotels, SIM cards, tours and transport in one place',
            },
            {
                title: 'Savings',
                desc: 'Best prices, deals and exclusive promo codes',
            },
            {
                title: 'Guides',
                desc: 'Detailed routes and tips from travelers',
            },
            {
                title: 'Up-to-date info',
                desc: 'Fresh details on prices, visas and entry rules',
            },
        ],
    },
    ru: {
        metaTitle: 'Путеводитель для путешествий',
        metaDescription:
            'TripLinkHub – ваш помощник в путешествиях: сравните туры, проживание, транспорт, eSIM и VPN для популярных направлений. Удобный поиск, реальные отзывы, лучшие предложения по цене.',
        heroTitle: 'Ваше лучшее путешествие',
        heroTitleAccent: 'начинается здесь',
        heroSubtitle:
            'Маршруты, гайды и проверенные сервисы для самостоятельных путешествий – всё в одном месте',
        ctaDestination: 'Выбрать направление',
        sectionDestinations: 'Направления',
        sectionDestinationsTitle: 'Выберите страну',
        sectionDestinationsDesc:
            'Полные путеводители с маршрутами, советами и подборками лучших сервисов',
        sectionBenefits: 'Преимущества',
        sectionBenefitsTitle: 'Почему TripLinkHub?',
        sectionJournal: 'Журнал',
        sectionJournalTitle: 'Статьи и гайды',
        sectionCta: 'Время увидеть больше',
        sectionCtaTitle: 'Готовы к новым впечатлениям?',
        sectionCtaDesc:
            'Выберите направление и начинайте планировать идеальную поездку',
        features: [
            {
                title: 'Подборки',
                desc: 'Отели, SIM-карты, туры и транспорт в одном месте',
            },
            {
                title: 'Экономия',
                desc: 'Лучшие цены, акции и эксклюзивные промокоды',
            },
            {
                title: 'Гайды',
                desc: 'Детальные маршруты и советы реальных путешественников',
            },
            {
                title: 'Актуальность',
                desc: 'Свежие данные о ценах, визах и условиях въезда',
            },
        ],
    },
};
